<template>
  <div>
    <!-- 모집중인 대출이 없을 때 신청하기 버튼 -->
    <v-row v-if="ongoingFastLoan.length === 0" class="mb-2">
      <v-col>
        <BasicButton
          class="basic-button--apply-important"
          @click="moveToLoan()"
          header="급할 때 당겨쓰고 편리하게 일상환"
          :footer="showFooter ? '제휴 금융사인 펀다에이아이가 제공합니다' : ''"
        >
          비상금 신청하기
        </BasicButton>
      </v-col>
    </v-row>

    <!-- 진행중인 대출이 있을 때 -->
    <template v-else>
      <v-row v-for="(loan, index) in ongoingFastLoan" :key="loan.uuid" class="mb-2">
        <v-col>
          <!-- 투자중 상태 -->
          <router-link
            v-if="loan.status === 'investing'"
            style="text-decoration: none; color: inherit"
            :to="{ path: `loan/${loan.uuid}/investing` }"
          >
            <h4 class="mb-2">
              비상금{{ ongoingFastLoan.length > 1 ? '#' + (index + 1) : '' }} 모집 현황
            </h4>
            <v-progress-linear
              :value="getInvestingPercent(loan)"
              color="primary"
              :height="25"
              rounded
            >
              <template v-slot:default>
                <strong class="white--text">
                  {{ commaFormat(investingAmounts[loan.uuid] || 0) }} 원
                </strong>
              </template>
            </v-progress-linear>
          </router-link>

          <!-- 모집 완료 상태 -->
          <router-link
            v-else-if="loan.status === 'invested'"
            style="text-decoration: none; color: inherit"
            :to="{ path: `loan/${loan.uuid}/investing` }"
          >
            <h4 class="mb-2">
              비상금{{ ongoingFastLoan.length > 1 ? '#' + (index + 1) : '' }} 모집 현황
            </h4>
            <v-progress-linear :value="100" color="primary" :height="52" rounded>
              <template v-slot:default>
                <strong class="white--text">모집 종료 - 계약서 작성하기</strong>
              </template>
            </v-progress-linear>
          </router-link>

          <!-- 실행중 상태 -->
          <router-link
            v-else-if="loan.status === 'executing'"
            style="text-decoration: none; color: inherit"
            :to="{ path: `loan/${loan.uuid}/investing` }"
          >
            <h4 class="mb-2">
              비상금{{ ongoingFastLoan.length > 1 ? '#' + (index + 1) : '' }} 모집 현황
            </h4>
            <v-progress-linear :value="100" color="primary" :height="52" rounded>
              <template v-slot:default>
                <strong class="white--text">대출금 송금 준비중</strong>
              </template>
            </v-progress-linear>
          </router-link>

          <!-- 실행 완료 상태 -->
          <BasicButton
            v-else-if="loan.status === 'executed'"
            class="basic-button--apply"
            :footer="showFooter ? '제휴 금융사인 펀다에이아이가 제공합니다' : ''"
            :to="{ name: 'loan/repayment', params: { uuid: loan.uuid } }"
          >
            비상금{{ ongoingFastLoan.length > 1 ? '#' + (index + 1) : '' }} 이용내역
          </BasicButton>
        </v-col>
      </v-row>
    </template>

    <!-- 우리동네 크라우드 펀딩 버튼 -->
    <v-row class="mb-2" v-if="showWooriCrowdButton">
      <v-col v-if="ongoingWooricrowds.length === 0">
        <BasicButton
          class="basic-button--apply"
          @click="moveToWooriCrowd()"
          header="정책자금으로 이자와 수수료를 모두 페이백!"
          :footer="showFooter ? '제휴 금융사인 펀다에이아이가 제공합니다' : ''"
        >
          우리동네 크라우드 펀딩
        </BasicButton>
      </v-col>
      <template v-else>
        <v-row v-for="(loan, index) in ongoingWooricrowds" :key="loan.uuid" class="mb-2">
          <v-col>
            <!-- 투자중 상태 -->
            <router-link
              v-if="loan.status === 'investing'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                우리동네 크라우드 펀딩{{ ongoingWooricrowds.length > 1 ? '#' + (index + 1) : '' }}
                모집 현황
              </h4>
              <v-progress-linear
                :value="getInvestingPercent(loan)"
                color="primary"
                :height="25"
                rounded
              >
                <template v-slot:default>
                  <strong class="white--text">
                    {{ commaFormat(investingAmounts[loan.uuid] || 0) }} 원
                  </strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 모집 완료 상태 -->
            <router-link
              v-else-if="loan.status === 'invested'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                우리동네 크라우드 펀딩{{ ongoingWooricrowds.length > 1 ? '#' + (index + 1) : '' }}
                모집 현황
              </h4>
              <v-progress-linear :value="100" color="primary" :height="52" rounded>
                <template v-slot:default>
                  <strong class="white--text">모집 종료 - 계약서 작성하기</strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 실행중 상태 -->
            <router-link
              v-else-if="loan.status === 'executing'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                우리동네 크라우드 펀딩{{ ongoingWooricrowds.length > 1 ? '#' + (index + 1) : '' }}
                모집 현황
              </h4>
              <v-progress-linear :value="100" color="primary" :height="52" rounded>
                <template v-slot:default>
                  <strong class="white--text">대출금 송금 준비중</strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 실행 완료 상태 -->
            <BasicButton
              v-else-if="loan.status === 'executed'"
              class="basic-button--apply"
              :to="{ name: 'loan/repayment', params: { uuid: loan.uuid } }"
            >
              우리동네 크라우드 펀딩{{ ongoingWooricrowds.length > 1 ? '#' + (index + 1) : '' }}
              이용내역
            </BasicButton>
          </v-col>
        </v-row>
      </template>
    </v-row>

    <!-- 펀다에이아이BNPL 결제 버튼 -->
    <v-row class="mb-2">
      <v-col v-if="ongoingBnplJangsa3.length === 0">
        <BasicButton
          class="basic-button--apply"
          @click="moveToFundaBNPL()"
          header="현금 없이 바로 이용하는 펀다에이아이BNPL 결제"
          :footer="showFooter ? '제휴 금융사인 펀다에이아이가 제공합니다' : ''"
        >
          펀다에이아이BNPL 결제
        </BasicButton>
      </v-col>
      <template v-else>
        <v-row v-for="(loan, index) in ongoingBnplJangsa3" :key="loan.uuid" class="mb-2">
          <v-col>
            <!-- 투자중 상태 -->
            <router-link
              v-if="loan.status === 'investing'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                펀다에이아이BNPL 결제{{ ongoingBnplJangsa3.length > 1 ? '#' + (index + 1) : '' }}
                모집 현황
              </h4>
              <v-progress-linear
                :value="getInvestingPercent(loan)"
                color="primary"
                :height="25"
                rounded
              >
                <template v-slot:default>
                  <strong class="white--text">
                    {{ commaFormat(investingAmounts[loan.uuid] || 0) }} 원
                  </strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 모집 완료 상태 -->
            <router-link
              v-else-if="loan.status === 'invested'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                펀다에이아이BNPL 결제{{ ongoingBnplJangsa3.length > 1 ? '#' + (index + 1) : '' }}
                모집 현황
              </h4>
              <v-progress-linear :value="100" color="primary" :height="52" rounded>
                <template v-slot:default>
                  <strong class="white--text">모집 종료 - 계약서 작성하기</strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 실행중 상태 -->
            <router-link
              v-else-if="loan.status === 'executing'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                펀다에이아이BNPL 결제{{ ongoingBnplJangsa3.length > 1 ? '#' + (index + 1) : '' }}
                모집 현황
              </h4>
              <v-progress-linear :value="100" color="primary" :height="52" rounded>
                <template v-slot:default>
                  <strong class="white--text">대출금 송금 준비중</strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 실행 완료 상태 -->
            <BasicButton
              v-else-if="loan.status === 'executed'"
              class="basic-button--apply"
              :to="{ name: 'loan/repayment', params: { uuid: loan.uuid } }"
            >
              펀다에이아이BNPL 결제{{ ongoingBnplJangsa3.length > 1 ? '#' + (index + 1) : '' }}
              이용내역
            </BasicButton>
          </v-col>
        </v-row>
      </template>
    </v-row>

    <!-- 펀다에이아이 집금 서비스 버튼 -->
    <v-row class="mb-2">
      <!-- 신청 버튼: 무조건 항상 표시 -->
      <v-col>
        <BasicButton
          class="basic-button--apply"
          @click="moveToFundaBNPL()"
          header="매월 찾아오는 대금 결제일을 대비한 집금 서비스"
          :footer="showFooter ? '제휴 금융사인 펀다에이아이가 제공합니다' : ''"
        >
          펀다에이아이 집금 서비스
        </BasicButton>
      </v-col>

      <!-- 진행 중인 대출이 있을 경우: 상태별 출력 -->
      <template v-if="ongoingBnplInsur.length > 0">
        <v-row v-for="(loan, index) in ongoingBnplInsur" :key="loan.uuid" class="mb-2">
          <v-col>
            <!-- 투자중 상태 -->
            <router-link
              v-if="loan.status === 'investing'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                펀다에이아이 집금  서비스{{ ongoingBnplInsur.length > 1 ? '#' + (index + 1) : '' }} 모집 현황
              </h4>
              <v-progress-linear
                :value="getInvestingPercent(loan)"
                color="primary"
                :height="25"
                rounded
              >
                <template v-slot:default>
                  <strong class="white--text">
                    {{ commaFormat(investingAmounts[loan.uuid] || 0) }} 원
                  </strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 모집 완료 상태 -->
            <router-link
              v-else-if="loan.status === 'invested'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                펀다에이아이 집금 서비스{{ ongoingBnplInsur.length > 1 ? '#' + (index + 1) : '' }} 모집 현황
              </h4>
              <v-progress-linear :value="100" color="primary" :height="52" rounded>
                <template v-slot:default>
                  <strong class="white--text">모집 종료 - 계약서 작성하기</strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 실행중 상태 -->
            <router-link
              v-else-if="loan.status === 'executing'"
              style="text-decoration: none; color: inherit"
              :to="{ path: `loan/${loan.uuid}/investing` }"
            >
              <h4 class="mb-2">
                펀다에이아이 집금 서비스{{ ongoingBnplInsur.length > 1 ? '#' + (index + 1) : '' }} 모집 현황
              </h4>
              <v-progress-linear :value="100" color="primary" :height="52" rounded>
                <template v-slot:default>
                  <strong class="white--text">대출금 송금 준비중</strong>
                </template>
              </v-progress-linear>
            </router-link>

            <!-- 실행 완료 상태 -->
            <BasicButton
              v-else-if="loan.status === 'executed'"
              class="basic-button--apply"
              :to="{ name: 'loan/repayment', params: { uuid: loan.uuid } }"
            >
              펀다에이아이 집금 서비스{{ ongoingBnplInsur.length > 1 ? '#' + (index + 1) : '' }} 이용내역
            </BasicButton>
          </v-col>
        </v-row>
      </template>
</v-row>

    <!-- 집금 진행중(BNPL_COLLECTION) - 자동 생성/모집되어 실행 결과만 표시: 이용내역 전용 -->
    <v-row class="mb-2" v-if="bnplCollectionExecuted.length > 0">
      <v-col cols="12" v-for="(loan, index) in bnplCollectionExecuted" :key="loan.uuid">
        <BasicButton
          class="basic-button--apply"
          :to="{ name: 'loan/repayment', params: { uuid: loan.uuid } }"
          :footer="showFooter ? '제휴 금융사인 펀다에이아이가 제공합니다' : ''"
        >
          집금{{ bnplCollectionExecuted.length > 1 ? '#' + (index + 1) : '' }} 이용내역
        </BasicButton>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'
import { commaFormat } from '@/filter/number'

export default {
  name: 'LoanButtons',
  components: {
    BasicButton: () => import('@/components/common/button/BasicButton.vue'),
  },
  props: {
    showFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      investingAmounts: {},
    }
  },
  computed: {
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
    ...mapState('myfinbiz', ['organization']),
    ...mapGetters('loan', [
      'ongoingFastLoan',
      'isEarlyPaymentEnabled',
      'ongoingWooricrowds',
      'executedWooriCrowd',
      'ongoingBnplJangsa3',
  'ongoingBnplInsur',
  'ongoingBnplCollection',
    ]),
    showWooriCrowdButton() {
      return true
    },
    bnplCollectionExecuted() {
      // BNPL_COLLECTION은 자동 생성/모집되어 실행 완료건만 노출
      return (this.ongoingBnplCollection || []).filter((l) => l.status === 'executed')
    },
  },
  methods: {
    ...mapActions('evaluation', ['isKcsAgreements', 'isHometaxAccounts']),
    commaFormat,
    async moveToLoan() {
      this.$emit('show-transition', '/loan/fast-loan-300-intro')
    },
    async moveToFundaBNPL() {
      this.$emit('show-transition', '/loan/funda-bnpl-intro')
    },
    moveToWooriCrowd() {
      this.$emit('show-transition', { name: 'woori-crowd-intro' })
    },
    getInvestingPercent(loan) {
      console.log('loan = ', loan)
      if (!loan) return 0
      const amount = this.investingAmounts[loan.uuid] || 0
      return ((amount / loan.amount) * 100).toFixed(0)
    },
    async updateInvestingAmount(loan) {
      if (loan.status === 'investing') {
        const { data } = await defaultApi.getInvestingAmount(loan.uuid)
        this.$set(this.investingAmounts, loan.uuid, data || 0)
      }
    },
  },
  watch: {
    ongoingFastLoan: {
      immediate: true,
      async handler(loans) {
        if (!loans || loans.length === 0) return
        for (const loan of loans) {
          await this.updateInvestingAmount(loan)
        }
      },
    },
    ongoingWooricrowds: {
      immediate: true,
      async handler(loans) {
        if (!loans || loans.length === 0) return
        for (const loan of loans) {
          await this.updateInvestingAmount(loan)
        }
      },
    },
    ongoingBnplJangsa3: {
      immediate: true,
      handler(loans) {
        console.log('ongoingBnplJangsa3 = ', loans)
        if (!loans || loans.length === 0) return
        for (const loan of loans) {
          console.log('BNPL loan status = ', loan.status)
          console.log('BNPL loan amount = ', loan.amount)
          this.updateInvestingAmount(loan)
        }
      },
    },
    ongoingBnplInsur: {
      immediate: true,
      handler(loans) {
        if (!loans || loans.length === 0) return
        for (const loan of loans) {
          this.updateInvestingAmount(loan)
        }
      },
    },
  // BNPL_COLLECTION은 이용내역(실행완료)만 표시하므로 추가 업데이트 불필요
  },
}
</script>

<style lang="scss" scoped>
.basic-button--apply {
  background-color: #4163d5 !important;
  border-radius: 1px;

  :deep(.message-container) {
    .body {
      color: #ffffff !important;
    }
  }
}
.basic-button--apply-important {
  background-color: #4163d5 !important;
  border-radius: 1px;

  :deep(.message-container) {
    .body {
      color: #ffd700 !important;
    }
  }
}
</style>